import { useEffect, useState } from 'react';
import { Card } from 'antd';

import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { Card as CustomCard } from './components/Card';

import { Container, Content, SearchBar } from './styles';
import { FiSearch } from 'react-icons/fi';
import { apiNode } from '../../services/api';
import { SuccessInviteModal } from './components/SuccessInviteModalOpen';
import { useNavigate } from 'react-router-dom';

interface UserProps {
  id: number;
  name: string;
  sobrenome: string;
  foto: string;
}

interface UserAPIResponse {
  users: UserProps[];
}

export const LeagueUsers = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<UserProps[]>([]);
  const [selectedUser, setSelectedUser] = useState<UserProps>({} as UserProps);

  const [username, setUsername] = useState('');

  const [isSuccessInviteModalOpen, setIsSuccessInviteModalOpen] =
    useState(false);

  useEffect(() => {
    try {
      setIsLoading(true);
      const getUserInfo = async () => {
        const leagueResponse = await apiNode.get('/ligas/users').catch(() => {
          navigate('/leagues');
        });

        if (leagueResponse) {
          const { isAdmin } = leagueResponse.data.participante;

          if (!isAdmin) {
            navigate('/leagues');
            return;
          }
        }
      };

      getUserInfo();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    try {
      const getUsers = async () => {
        setIsLoading(true);
        const response =
          await apiNode.get<UserAPIResponse>(`/participantes/users?limit=${40}
        &nome=${username}
        `);

        setUsers(response.data.users);
        setIsLoading(false);
      };

      getUsers();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [username]);

  const handleOpenSuccessModal = (user: UserProps) => {
    setIsSuccessInviteModalOpen(true);
    setSelectedUser(user);
  };

  return (
    <Container>
      <Header />
      <Content>
        <span>
          <h1>Convidar Jogadores</h1>

          <SearchBar>
            <FiSearch size={15} />
            <input
              type="text"
              placeholder="Encontre um jogador"
              onChange={(event) => setUsername(event.target.value)}
            />
          </SearchBar>
        </span>

        <div>
          {isLoading && (
            <>
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
            </>
          )}

          {!isLoading &&
            users.length > 0 &&
            users.map((user) => (
              <CustomCard
                key={user.id}
                user={user}
                openSuccessModal={handleOpenSuccessModal}
              />
            ))}

          {!isLoading && users.length < 1 && <h1>Nenhum jogador disponível</h1>}
        </div>
      </Content>
      <Footer />

      <SuccessInviteModal
        closeModal={() => setIsSuccessInviteModalOpen(false)}
        isOpen={isSuccessInviteModalOpen}
        user={selectedUser}
      />
    </Container>
  );
};
